(() => {
  const controllerKey = '__spacetekJudgeMeModalController';

  if (window[controllerKey]) {
    return;
  }

  const modalSelector = '.jdgm-modal.jdgm-widget-revamp';
  const sourceSelector = '.spacetek-judgeme-section[data-sj-modal-styling="true"] .jdgm-review-card';
  const modalVariableNames = [
    '--sj-modal-overlay-color',
    '--sj-modal-overlay-opacity',
    '--sj-modal-border-color',
    '--sj-modal-border-width',
    '--sj-modal-media-background',
    '--sj-modal-review-background',
    '--sj-modal-review-text',
    '--sj-modal-metadata',
    '--sj-modal-stars',
    '--sj-modal-reviewer',
    '--sj-modal-verified-text',
    '--sj-modal-product-background',
    '--sj-modal-product-link',
    '--sj-modal-close-color',
    '--sj-modal-close-background',
    '--sj-modal-close-background-opacity',
    '--sj-modal-nav-color',
    '--sj-modal-nav-background',
    '--sj-modal-nav-background-opacity'
  ];

  let pendingSource = null;
  let pendingTimer = 0;
  let markedModal = null;
  let markedSourceId = null;
  let observer = null;
  let reconcileFrame = 0;

  window[controllerKey] = true;

  const getGalleryShell = (modal) => modal.querySelector(
    ':scope > .jdgm-modal__content[aria-label="Review Media Gallery"]'
  );

  const isVisible = (element) => {
    if (!element || !element.isConnected) {
      return false;
    }

    const style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && element.getClientRects().length > 0;
  };

  const stopObservingIfIdle = () => {
    if (!pendingSource && !markedModal && observer) {
      observer.disconnect();
      observer = null;
    }
  };

  const clearPending = () => {
    if (pendingTimer) {
      window.clearTimeout(pendingTimer);
      pendingTimer = 0;
    }

    pendingSource = null;
    stopObservingIfIdle();
  };

  const cleanupMarkedModal = () => {
    if (!markedModal) {
      return;
    }

    markedModal.classList.remove('spacetek-judgeme-modal');
    modalVariableNames.forEach((name) => markedModal.style.removeProperty(name));
    markedModal = null;
    markedSourceId = null;
    stopObservingIfIdle();
  };

  const startObserving = () => {
    if (observer || !document.body) {
      return;
    }

    observer = new MutationObserver(scheduleReconcile);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-hidden', 'class', 'hidden', 'style']
    });
  };

  const markModal = (modal, source) => {
    if (markedModal && markedModal !== modal) {
      cleanupMarkedModal();
    }

    const sourceStyles = window.getComputedStyle(source);
    modalVariableNames.forEach((name) => {
      modal.style.setProperty(name, sourceStyles.getPropertyValue(name).trim());
    });

    modal.classList.add('spacetek-judgeme-modal');
    markedModal = modal;
    markedSourceId = source.dataset.sjSectionId || null;
  };

  const findVisibleGalleryModal = () => Array.from(document.querySelectorAll(modalSelector)).find(
    (modal) => isVisible(modal) && Boolean(getGalleryShell(modal))
  );

  const reconcile = () => {
    reconcileFrame = 0;

    if (markedModal && (!isVisible(markedModal) || !getGalleryShell(markedModal))) {
      cleanupMarkedModal();
    }

    if (pendingSource) {
      if (!pendingSource.isConnected || pendingSource.dataset.sjModalStyling !== 'true') {
        clearPending();
        return;
      }

      const modal = findVisibleGalleryModal();
      if (modal) {
        markModal(modal, pendingSource);
        clearPending();
      }
    }

    stopObservingIfIdle();
  };

  function scheduleReconcile() {
    if (reconcileFrame) {
      return;
    }

    reconcileFrame = window.requestAnimationFrame(reconcile);
  }

  const setPendingSource = (source) => {
    clearPending();
    pendingSource = source;
    startObserving();
    scheduleReconcile();
    pendingTimer = window.setTimeout(() => {
      clearPending();
    }, 2000);
  };

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) {
      return;
    }

    const card = event.target.closest(sourceSelector);
    if (card) {
      setPendingSource(card.closest('.spacetek-judgeme-section'));
      return;
    }

    if (markedModal && event.target.closest('.jm-indicator__close, .jdgm-modal__overlay')) {
      window.requestAnimationFrame(scheduleReconcile);
    }
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && markedModal) {
      window.requestAnimationFrame(scheduleReconcile);
    }
  }, true);

  document.addEventListener('shopify:section:unload', (event) => {
    const sectionId = event.detail && event.detail.sectionId;
    if (!sectionId) {
      return;
    }

    if (pendingSource && pendingSource.dataset.sjSectionId === sectionId) {
      clearPending();
    }

    if (markedSourceId === sectionId) {
      cleanupMarkedModal();
    }
  });
})();
